<template>
  <div class="forget-password">
    <b-container class="p-0 pm-2">
      <b-card class="card-login">
        <img v-if="logoSrc" :src="getImgUrl(logoSrc)" class="d-block mx-auto" />
        <h2 v-if="titleH2" class="mt-3 mb-4" v-html="titleH2"></h2>
        <b-row>
          <b-col>
            <h6 v-if="welcomeHeader" class="welecomeH6" v-bind:class="[{
              'welecomeMIDH6 mt-5': guard == 'MID',
              'welecomeDYH6 mt-1 text-center': guard == 'DY',
              'welecomeDoorderH6 mt-5': guard == 'DOORDER',
              'welecomeAVH6 mt-3 text-center': guard == 'AV',
              'welcomeGHH6 mt-3': guard == 'GARDENHELP',
              'welcomeCRiskH6 mt-3': guard == 'CRISK',
            }, welcome_header_class]">
              {{ welcomeHeader }}
            </h6>
            <p v-if="welcomeSubheader" class="welcomeP" v-bind:class="[{
              welecomeMIDP: guard == 'MID',
              'welecomeDYP mt-3': guard == 'DY',
              'welecomeDoorderP mb-3': guard == 'DOORDER',
              'welecomeAVP mt-3': guard == 'AV',
              'welcomeGHP mb-3': guard == 'GARDENHELP',
            }, welcome_subheader_class]">
              {{ welcomeSubheader }}
            </p>
          </b-col>
        </b-row>
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col>
              <b-form-group id="email-input-group" :label="guard == 'CRISK' ? $t('email') : ''" label-for="email"
                :label-class="[{
                }, form_label_auth_class]">
                <b-form-input id="email" class="form-control-auth" v-bind:class="[{
                  'form-control-auth-mid': guard == 'MID',
                  'form-control-auth-doom-yoga': guard == 'DY',
                  'form-control-auth-doorder': guard == 'DOORDER',
                  'form-control-auth-astrology': guard == 'AV',
                  'form-control-auth-garden-help': guard == 'GARDENHELP',
                }, form_control_auth_class]" v-model="form.email" type="email"
                  :placeholder="guard == 'CRISK' ? $t('email') : ''" autofocus @keydown.space.prevent
                  required></b-form-input>
              </b-form-group></b-col></b-row>
          <input type="hidden" name="guard" v-model="guard" />
          <div class="d-flex justify-content-center align-content-center" v-bind:class="[{
            'mt-5': guard === 'MID',
            'mt-2': guard === 'DY' || guard === 'DOORDER' || guard === 'AV',
            'submitButtonContainerGH mt-3': guard === 'GARDENHELP',
          }, submit_button_container_class]">
            <button class="btn" v-bind:class="[{
              'btn-login-mid': guard === 'MID',
              'btn-login-dy': guard === 'DY',
              'btn-login-doorder': guard === 'DOORDER',
              'btn-login-av': guard === 'AV',
              'btn-login-garden-help': guard === 'GARDENHELP',
            }, btn_login_class]" type="submit">
              {{ $t('send_email_btn') }}
            </button>
          </div>
          <div class="d-flex justify-content-center align-content-center mt-2">
            <p v-bind:class="[{
              rememberPasswordMIDP: guard == 'MID',
              rememberPasswordDYP: guard == 'DY',
              rememberPasswordDoorderP: guard == 'DOORDER',
              rememberPasswordAVP: guard == 'AV',
              rememberPasswordGHP: guard == 'GARDENHELP',
            }, remember_password_p]">
              {{ $t('remember_password') }}
              <router-link :to="'/' + clientLink + '/login' + (user_type ? '/' + user_type : '')" v-bind:class="[{
                forgetPasswordCRiskA: guard == 'CRISK'
              }, forget_password_link_class]">{{ $t('login_btn') }}
              </router-link>
            </p>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ForgetPassword",
  props: [
    "titleH2",
    "logoSrc",
    "guard", "welcomeHeader", "welcome_header_class",
    "welcomeSubheader", "welcome_subheader_class",
    "alert_danger_class", "form_label_auth_class", "form_control_auth_class",
    "forget_password_link_class", "remember_password_p",
    "submit_button_container_class", "btn_login_class",

    "clientLink",
    "user_type"
  ],
  data() {
    return {
      form: {
        email: "",
        guard: this.guard,
      },

      swal_confirm_button_class: "",
      swal_container_class: "",

      user_type: null
    };
  },
  mounted() {
    this.user_type = this.$route.params.type;

    if (this.guard == "GARDENHELP") {
      this.swal_confirm_button_class =
        "btn btn-bumblebee btn-gardenhelp  btn-gardenhelp-primary";
      this.swal_container_class = "swal-container-garden-help";
    } 
  },
  methods: {
    getImgUrl(imgname) {
      // var images = require.context("@/assets/images/", false, /\.png$/);
      // return images("./" + imgname );

      return require("@/assets/images/" + imgname);
    },
    onSubmit() {
      console.log(window.localStorage);
      console.log("forget pssword submit");
      console.log(this.$parent.$parent.isLogin);
      console.log(this.form);

      if (this.guard == 'GARDENHELP') {
        axios
          .post(
            `${this.user_type === 'customer' ? 'user' : 'operator'}/forget-password`,
            {
              email: this.form.email,
              client: this.form.guard,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                client: this.guard,
              },
            }
          )
          .then((response) => {
            console.log(response);
            console.log(response.data);
            // console.log("ssss")
            window.sessionStorage.setItem("email", this.form.email)
            this.$router.push({ name: "GardenHelpResetPasswordCode", params: {
              type: this.user_type === 'customer' ? 'user' : 'operator'
            } });
            //   window.localStorage.setItem("user", JSON.stringify(response.data));
            // // this.$parent.$parent.isLogin = true;
            //   
          });
      } else if (this.guard == 'CRISK') {
        console.log("before send forget password request", this.guard, this.form.guard)
        axios
          .post(
            "user/forget-password",
            {
              email: this.form.email,
              client: this.form.guard,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                client: this.client_name,
              },
            }
          )
          .then((response) => {
            console.log(response);
            console.log(response.data);
            // console.log("ssss")
            window.sessionStorage.setItem("email", this.form.email)
            this.$router.push({ name: "CRiskResetPasswordCode" });
            //   window.localStorage.setItem("user", JSON.stringify(response.data));
            // // this.$parent.$parent.isLogin = true;
            //   
          }).catch((error) => {
            this.sendForgetPasswordRequestAdmin()
            // console.log(error);
            // console.log(error.response);
            // console.log(error.response.data.error);
            // console.log(error.request);
            // console.log(error.message);
            // this.$fire({
            //   // title: "Title",
            //   text: error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message,
            //   type: "error",
            //   // timer: 3000,
            //   customClass: {
            //     container: this.swal_container_class,
            //     confirmButton: this.swal_confirm_button_class,
            //   },
            // }).then((r) => {
            //   // console.log(r.value);
            //   // this.$router.push({ name: "CRiskResetPasswordCode" });

            // });
            // document.body.classList.remove("swal2-height-auto");
          });


      }


    },

    sendForgetPasswordRequestAdmin() {
      console.log("in send request forget password -- admin", this.form.guard, this.guard)
      axios
        .post(
          "admin/forget-password",
          {
            email: this.form.email,
            client: this.form.guard,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
            },
          }
        )
        .then((response) => {
          console.log(response);
          console.log(response.data);
          // console.log("ssss")
          window.sessionStorage.setItem("email", this.form.email)
          this.$router.push({ name: "CRiskResetPasswordCode", params: { type: 'admin' } });
          //   window.localStorage.setItem("user", JSON.stringify(response.data));
          // // this.$parent.$parent.isLogin = true;
          //   
        }).catch((error) => {
          console.log(error);
          console.log(error.response);
          console.log(error.response.data.error);
          console.log(error.request);
          console.log(error.message);
          this.$fire({
            // title: "Title",
            text: error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message,
            type: "error",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            // this.$router.push({ name: "CRiskResetPasswordCode" });

          });
          document.body.classList.remove("swal2-height-auto");
        });
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/auth/ForgetPassword.vue